import Weixin from '@/util/weixin';

const storeKey = 'app-state-session'
const scopeKey = 'app-state-scope'

function isValid(session) {
  return session && session.timestamp + session.expire * 1000 > new Date().getTime() + session.span
}

function getStorage() {
  return Weixin.isWxWork() ? sessionStorage : localStorage;
}

export default {
  get() {
    const str = getStorage().getItem(storeKey)
    if (str) {
      return JSON.parse(str)
    }
    return null
  },
  set(session) {
    session.span = session.timestamp - new Date().getTime()
    sessionStorage.removeItem(scopeKey)
    return getStorage().setItem(storeKey, JSON.stringify(session))
  },
  remove() {
    sessionStorage.removeItem(scopeKey)
    return getStorage().removeItem(storeKey)
  },
  valid() {
    const session = this.get();
    return isValid(session);
  },
  // Authorization Header
  getToken() {
    const session = this.get()
    if (!isValid(session)) {
      getStorage().removeItem(storeKey)
      return null
    }
    return session.token
  },
  getAccount() {
    const session = this.get()
    if (!isValid(session)) {
      getStorage().removeItem(storeKey)
      return null
    }
    return session.account
  },
  getScopeCompany() {
    return sessionStorage.getItem(scopeKey)
  },
  setScopeCompany(scopeCompany) {
    if (!scopeCompany) {
      sessionStorage.removeItem(scopeKey);
    } else {
      sessionStorage.setItem(scopeKey, scopeCompany);
    }
  }
}